webpackJsonp([186063380969677],{

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(16);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _SiteConfig = __webpack_require__(13);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SEO = function (_Component) {
	  _inherits(SEO, _Component);
	
	  function SEO() {
	    _classCallCheck(this, SEO);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  SEO.prototype.render = function render() {
	    var _props = this.props,
	        postNode = _props.postNode,
	        postPath = _props.postPath,
	        postSEO = _props.postSEO;
	
	    var title = void 0;
	    var description = void 0;
	    var image = void 0;
	    var postURL = void 0;
	    if (postSEO) {
	      var postMeta = postNode;
	      title = postMeta.title;
	      description = postMeta.description ? postMeta.description : postNode.excerpt;
	      image = postMeta.cover;
	      postURL = _SiteConfig2.default.siteUrl + _SiteConfig2.default.pathPrefix + postPath;
	    } else {
	      title = _SiteConfig2.default.siteTitle;
	      description = _SiteConfig2.default.siteDescription;
	      image = _SiteConfig2.default.siteLogo;
	    }
	    var realPrefix = _SiteConfig2.default.pathPrefix === "/" ? "" : _SiteConfig2.default.pathPrefix;
	    image = _SiteConfig2.default.siteUrl + realPrefix + image;
	    var blogURL = _SiteConfig2.default.siteUrl + _SiteConfig2.default.pathPrefix;
	    var schemaOrgJSONLD = [{
	      "@context": "http://schema.org",
	      "@type": "WebSite",
	      url: blogURL,
	      name: title,
	      alternateName: _SiteConfig2.default.siteTitleAlt ? _SiteConfig2.default.siteTitleAlt : ""
	    }];
	    if (postSEO) {
	      schemaOrgJSONLD.push([{
	        "@context": "http://schema.org",
	        "@type": "BreadcrumbList",
	        itemListElement: [{
	          "@type": "ListItem",
	          position: 1,
	          item: {
	            "@id": postURL,
	            name: title,
	            image: image
	          }
	        }]
	      }, {
	        "@context": "http://schema.org",
	        "@type": "BlogPosting",
	        url: blogURL,
	        name: title,
	        alternateName: _SiteConfig2.default.siteTitleAlt ? _SiteConfig2.default.siteTitleAlt : "",
	        headline: title,
	        image: {
	          "@type": "ImageObject",
	          url: image
	        },
	        description: description
	      }]);
	    }
	    return _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement("meta", { name: "description", content: description }),
	      _react2.default.createElement("meta", { name: "image", content: image }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify(schemaOrgJSONLD)
	      ),
	      _react2.default.createElement("meta", { property: "og:url", content: postSEO ? postURL : blogURL }),
	      postSEO ? _react2.default.createElement("meta", { property: "og:type", content: "article" }) : null,
	      _react2.default.createElement("meta", { property: "og:title", content: title }),
	      _react2.default.createElement("meta", { property: "og:description", content: description }),
	      _react2.default.createElement("meta", { property: "og:image", content: image }),
	      _react2.default.createElement("meta", {
	        property: "fb:app_id",
	        content: _SiteConfig2.default.siteFBAppID ? _SiteConfig2.default.siteFBAppID : ""
	      }),
	      _react2.default.createElement("meta", { name: "twitter:card", content: "summary_large_image" }),
	      _react2.default.createElement("meta", {
	        name: "twitter:creator",
	        content: _SiteConfig2.default.userTwitter ? _SiteConfig2.default.userTwitter : ""
	      }),
	      _react2.default.createElement("meta", { name: "twitter:title", content: title }),
	      _react2.default.createElement("meta", { name: "twitter:description", content: description }),
	      _react2.default.createElement("meta", { name: "twitter:image", content: image })
	    );
	  };
	
	  return SEO;
	}(_react.Component);
	
	exports.default = SEO;
	module.exports = exports["default"];

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  width: 600px;\n  margin: auto;\n\n  @media screen and (max-width: 768px) {\n    width: 90%;\n    margin-bottom: 50px;\n  }\n'], ['\n  width: 600px;\n  margin: auto;\n\n  @media screen and (max-width: 768px) {\n    width: 90%;\n    margin-bottom: 50px;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  width: 600px;\n  height: 200px;\n  background-image: url(', ');\n  background-size: cover;\n  background-position: center;\n  @media screen and (max-width: 768px) {\n    display: none;\n  }\n'], ['\n  width: 600px;\n  height: 200px;\n  background-image: url(', ');\n  background-size: cover;\n  background-position: center;\n  @media screen and (max-width: 768px) {\n    display: none;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  margin: 50px 0;\n\n  @media screen and (max-width: 768px) {\n    margin: 50px auto;\n\n    .PostItem--PostContent > h2 {\n      font-size: 2.2rem;\n    }\n  }\n\n  .PostItem__PostMeta {\n    position: relative;\n    padding: 5px 15px;\n    top: -15px;\n    left: 5px;\n    width: 90%;\n    background: #171717;\n  }\n\n  .PostItem__PostMeta,\n  .PostItem__PostMeta > p {\n    color: white;\n    font-family: Consolas, Menlo, Monaco, Andale Mono WT, Andale Mono,\n      Lucida Console, Lucida Sans Typewriter, DejaVu Sans Mono,\n      Bitstream Vera Sans Mono, Liberation Mono, Nimbus Mono L, Courier New,\n      Courier, monospace, monospace;\n    font-size: 1.3rem;\n  }\n\n  .PostItem--PostContent * {\n    transition: all 0.3s ease;\n  }\n\n  &:hover {\n    .PostItem--PostContent * {\n      color: #43ab60;\n    }\n  }\n'], ['\n  margin: 50px 0;\n\n  @media screen and (max-width: 768px) {\n    margin: 50px auto;\n\n    .PostItem--PostContent > h2 {\n      font-size: 2.2rem;\n    }\n  }\n\n  .PostItem__PostMeta {\n    position: relative;\n    padding: 5px 15px;\n    top: -15px;\n    left: 5px;\n    width: 90%;\n    background: #171717;\n  }\n\n  .PostItem__PostMeta,\n  .PostItem__PostMeta > p {\n    color: white;\n    font-family: Consolas, Menlo, Monaco, Andale Mono WT, Andale Mono,\n      Lucida Console, Lucida Sans Typewriter, DejaVu Sans Mono,\n      Bitstream Vera Sans Mono, Liberation Mono, Nimbus Mono L, Courier New,\n      Courier, monospace, monospace;\n    font-size: 1.3rem;\n  }\n\n  .PostItem--PostContent * {\n    transition: all 0.3s ease;\n  }\n\n  &:hover {\n    .PostItem--PostContent * {\n      color: #43ab60;\n    }\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PostListing = function (_Component) {
	  _inherits(PostListing, _Component);
	
	  function PostListing() {
	    _classCallCheck(this, PostListing);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  PostListing.prototype.getPostList = function getPostList() {
	    var postList = [];
	    this.props.postEdges.forEach(function (postEdge) {
	      if (postEdge.node.frontmatter.type === 'page') {
	        return;
	      }
	      postList.push({
	        path: postEdge.node.fields.slug,
	        tags: postEdge.node.frontmatter.tags,
	        cover: postEdge.node.frontmatter.cover,
	        title: postEdge.node.frontmatter.title,
	        category: postEdge.node.frontmatter.category,
	        date: postEdge.node.frontmatter.date,
	        month: postEdge.node.frontmatter.month,
	        year: postEdge.node.frontmatter.year,
	        author: postEdge.node.frontmatter.author,
	        excerpt: postEdge.node.excerpt,
	        timeToRead: postEdge.node.timeToRead,
	        description: postEdge.node.frontmatter.description,
	        external: postEdge.node.frontmatter.external,
	        id: postEdge.node.id
	      });
	    });
	
	    var postItems = [];
	    postList.forEach(function (post) {
	      if (post.external) {
	        postItems.push(_react2.default.createElement(
	          PostItem,
	          { key: post.id },
	          _react2.default.createElement(
	            'a',
	            { href: post.external },
	            _react2.default.createElement(CoverImage, { img: post.cover, className: 'postCover' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'PostItem__PostMeta' },
	              _react2.default.createElement(
	                'p',
	                null,
	                post.month,
	                ' ',
	                post.year,
	                ' by ',
	                post.author,
	                ' in ',
	                post.category
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'PostItem--PostContent' },
	              _react2.default.createElement(
	                'h2',
	                null,
	                post.title
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                post.description
	              )
	            )
	          )
	        ));
	      } else {
	        postItems.push(_react2.default.createElement(
	          PostItem,
	          { key: post.id },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: post.path },
	            _react2.default.createElement(CoverImage, { img: post.cover, className: 'postCover' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'PostItem__PostMeta' },
	              _react2.default.createElement(
	                'p',
	                null,
	                post.month,
	                ' ',
	                post.year,
	                ' by ',
	                post.author,
	                ' in ',
	                post.category
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'PostItem--PostContent' },
	              _react2.default.createElement(
	                'h2',
	                null,
	                post.title
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                post.description
	              )
	            )
	          )
	        ));
	      }
	    });
	    return postItems;
	  };
	
	  PostListing.prototype.render = function render() {
	    var postList = this.getPostList();
	    return _react2.default.createElement(
	      PostListingContainer,
	      null,
	      _react2.default.createElement(
	        'ul',
	        { className: 'PostListing' },
	        postList.map(function (post) {
	          return _react2.default.createElement(
	            'li',
	            { key: Math.random() },
	            post
	          );
	        })
	      )
	    );
	  };
	
	  return PostListing;
	}(_react.Component);
	
	exports.default = PostListing;
	
	
	var PostListingContainer = _styledComponents2.default.div(_templateObject);
	
	var CoverImage = _styledComponents2.default.div(_templateObject2, function (props) {
	  return props.img;
	});
	
	var PostItem = _styledComponents2.default.div(_templateObject3);
	module.exports = exports['default'];

/***/ }),

/***/ 1821:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  margin: 100px 0;\n\n  @media screen and (max-width: 768px) {\n    margin: 50px 0 50px;\n  }\n"], ["\n  margin: 100px 0;\n\n  @media screen and (max-width: 768px) {\n    margin: 50px 0 50px;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  margin: 50px auto;\n  text-align: center;\n  h1,\n  h3 {\n    margin: auto;\n    margin-bottom: 25px;\n  }\n  h1 {\n    width: 80%;\n  }\n  h3 {\n    width: 85%;\n  }\n"], ["\n  margin: 50px auto;\n  text-align: center;\n  h1,\n  h3 {\n    margin: auto;\n    margin-bottom: 25px;\n  }\n  h1 {\n    width: 80%;\n  }\n  h3 {\n    width: 85%;\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  max-width: 800px;\n  margin: auto;\n"], ["\n  max-width: 800px;\n  margin: auto;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  border-bottom: 0.5px solid black;\n  width: 60%;\n  margin: 50px auto;\n"], ["\n  border-bottom: 0.5px solid black;\n  width: 60%;\n  margin: 50px auto;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactHelmet = __webpack_require__(16);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _PostListing = __webpack_require__(53);
	
	var _PostListing2 = _interopRequireDefault(_PostListing);
	
	var _SEO = __webpack_require__(52);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _SiteConfig = __webpack_require__(13);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlogPage = function (_Component) {
	  _inherits(BlogPage, _Component);
	
	  function BlogPage() {
	    _classCallCheck(this, BlogPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  BlogPage.prototype.render = function render() {
	    var postEdges = this.props.data.allMarkdownRemark.edges;
	    return _react2.default.createElement(
	      BlogPageContainer,
	      null,
	      _react2.default.createElement(_reactHelmet2.default, { title: _SiteConfig2.default.siteTitle }),
	      _react2.default.createElement(_SEO2.default, { postEdges: postEdges }),
	      _react2.default.createElement(
	        PageBody,
	        null,
	        _react2.default.createElement(
	          PageHead,
	          null,
	          _react2.default.createElement(
	            "h1",
	            null,
	            "This is what our engineers and leadership are up to."
	          ),
	          _react2.default.createElement(
	            "h3",
	            null,
	            "At AppTree, we are fortunate to get to work cutting edge technologies, contribute to open-source and stay active in the community. You can learn more about what we are learning and the impact we are trying to have in our world by following our blog."
	          ),
	          _react2.default.createElement(Divider, null)
	        ),
	        _react2.default.createElement(_PostListing2.default, { postEdges: postEdges })
	      )
	    );
	  };
	
	  return BlogPage;
	}(_react.Component);
	
	exports.default = BlogPage;
	
	
	var BlogPageContainer = _styledComponents2.default.div(_templateObject);
	
	var PageHead = _styledComponents2.default.div(_templateObject2);
	
	var PageBody = _styledComponents2.default.main(_templateObject3);
	
	var Divider = _styledComponents2.default.div(_templateObject4);
	
	/* eslint no-undef: "off"*/
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-jsx-8b7b6ed6b2e2a0657d9c.js